import { Component, OnInit, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { RepairRequestDTO } from '../../models/RepairRequestDTO.model';
import { VesselType } from '../../../shared/models/vesselType.model';
import { LookupService } from '../../../..//front-user/shared/services/lookup.service';
import { Flag } from '../../../../front-user/shared/models/flag.model';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, ValidationErrors, FormArray } from '@angular/forms';
import { ResponseObject } from '../../../../shared/models/response-object.model';
import { ClassificationSociety } from '../../../..//front-user/shared/models/classificationSociety.model';
import { NearestLocation, Authority, AttachmentType, Languages, MesurementUnit, FrequencyUnit, Frequency } from '../../../../shared/models/enums.model';
import { Attachment } from '../../../..//front-user/shared/models/attachment.model';
import { RepairRequestService } from '../../services/repair-request.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AlertService } from '../../../..//shared/components/alert/alert.service';
import { fileService } from '../../../shared/services/file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { GlobalServices } from '../../../..//shared/services/global.service';
import { AdminResponseDto } from '../../models/adminResponseDto';
import { CustomValidators } from '../../models/custom-validator';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { FileValidator } from '../../../..//front-user/shared/validator/file-input.validator';
import { BaseRequest } from '../../../..//shared/models/base-request.model';
import { AppConfig } from '../../../..//shared/services/app.config';
import { AuthenticationService } from '../../../../front-user/shared/services/authentication.service';

//import { FileValidator } from 'src/app/shared/directives/InputFileValidator';


@Component({
  selector: 'app-create-repair-request',
  templateUrl: './create-repair-request.component.html',
  styleUrls: ['./create-repair-request.component.css']
})

export class CreateRepairRequestComponent implements OnInit {
  repairRequestForm: FormGroup;
  tabOneForm: FormGroup;
  tabTwoForm: FormGroup;
  tabThreeForm: FormGroup;
  tabFourForm: FormGroup;
  tabFiveForm: FormGroup;
  tabSixForm: FormGroup;
  tabSevenForm: FormGroup;
  submittedTabOneForm = false;
  submittedtabTwoForm = false;
  submittedtabThreeForm = false;
  submittedtabFourForm = false;
  submittedtabFiveForm = false;
  submittedtabSixForm = false;
  submittedtabSevenForm = false;
  repairRequestDTO: RepairRequestDTO = new RepairRequestDTO();
  vesselType: VesselType[];
  flag: Flag[];
  loading = false;
  nearestLocation = NearestLocation;
  authority = Authority;
  frequency = Frequency;
  frequencyKeys = Object.keys(this.frequency);
  authorityKeys = Object.keys(this.authority);
  nearestLocationKeys = Object.keys(this.nearestLocation);
  mesurementUnit = MesurementUnit;
  mesurementUnitKeys = Object.keys(this.mesurementUnit);
  // frequency = FrequencyUnit;
  //frequecyKeys = Object.keys(this.frequency);
  classificationSociety: ClassificationSociety[];
  submitted = false;
  responseObject: ResponseObject;
  attachments: Attachment[] = [];
  attachmentDic = {};
  isReadOnly: boolean;
  requestId: any;
  dockingPlanAttachmentUrl;
  generalArrangementAttachmentUrl;
  tankPlanAttachmentUrl;
  linesPlanAttachmentUrl;
  transvewseSectionPlanAttachmentUrl;
  gasCertificatePlanAttachmentUrl;
  detauiledScopeOfWorkAttachmentUrl;
  dockingPlanProgress: number;
  generalArrangementProgress: number;
  tankPlanProgress: number;
  linesPlanProgress: number;
  tranverseSectionPlanProgress: number;
  freeGasCertificateProgress: number;
  detailedScopeOfWorkProgress: number;
  displayedLang: string;
  numberRegex: string = '^[0-9]*$';
  fractionRegex: string = '^((([0-9])*)((\\.[0-9]{1,7})?)|([0-9])+((\\.[0-9]{1,7}))|([0-9])+((\\.)))$';
  showSuccessMessage: boolean;
  showUnsuccessMessage: boolean;
  showRequest = true;
  showSubmit = false;
  isErrorMessage: boolean = false;
  userInfo: any;
  baseRequestDTO: BaseRequest;
  tankPlanExist: string;
  dockingPlanExist: string;
  generalArrangementExist: string;
  linesPlanExist: string;
  transvewseSectionPlanExist: string;
  gasCertificatePlanExist: string;
  detauiledScopeOfWorkExist: string;
  @ViewChild('repairRequestTabs',{static: false}) repairRequestTabs: TabsetComponent;
  @ViewChild('tabOne',{static: false}) tabOneControls: ElementRef;
  @ViewChild('tabTwo',{static: false}) tabTwoControls: ElementRef;
  @ViewChild('tabThree',{static: false}) tabThreeControls: ElementRef;
  @ViewChild('tabSix',{static: false}) tabSixEl: ElementRef;
  @ViewChild('repair',{static: false}) namefield: ElementRef;

  constructor(private route: ActivatedRoute,
    private lookupService: LookupService,
    private fileService: fileService,
    private formBuilder: FormBuilder,
    private repairRequestService: RepairRequestService,
    private translate: TranslateService,
    private alertService: AlertService,
    private globalSrv: GlobalServices,
    private router: Router,
    private authSrevice: AuthenticationService) {
    if (history.state.data && history.state.data.requestId)
      this.requestId = history.state.data.requestId;



    //this.requestId = this.route.snapshot.params.Id;

    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.nearestLocationKeys = this.nearestLocationKeys.slice(this.nearestLocationKeys.length / 2);
    this.authorityKeys = this.authorityKeys.slice(this.authorityKeys.length / 2);
    this.mesurementUnitKeys = this.mesurementUnitKeys.slice(this.mesurementUnitKeys.length / 2);
    this.frequencyKeys = this.frequencyKeys.slice(this.frequencyKeys.length / 2);
    // this.frequecyKeys = this.frequecyKeys.slice(this.frequecyKeys.length / 2);


    this.repairRequestDTO = new RepairRequestDTO();
    this.buildForm();

  }

  ngOnInit() {
        this.isReadOnly = this.requestId != null ? true : false;

    if (history.state.data && history.state.data.isCompleted) {
      this.isReadOnly = true;

    }

    else if((!history.state.data )&&this.authSrevice.currentUserValue.IsAdmin){
      window.history.back();
    }
    // this.requestId ? this.repairRequestForm.disable() : null;

    //Get VesselType Lokup
    this.lookupService.getVesselTypes().subscribe(
      d => {
        this.vesselType = d.Data;
      }

    )
    //Get Flags Lokup
    this.lookupService.getFlags().subscribe(
      d => {
        this.flag = d.Data;
      }
    )

    //Get ClassificationSociety Lokup
    this.lookupService.getClassificationSociety().subscribe(
      d => {
        this.classificationSociety = d.Data;
      }
    )
    if (this.requestId) {
      this.getRepairRequest();

    }
  }

  ngAfterViewInit() {
    if (this.repairRequestTabs?.tabs?.length > 0) {
      this.repairRequestTabs.tabs[1].disabled = !this.repairRequestTabs.tabs[1].disabled;
      this.repairRequestTabs.tabs[2].disabled = !this.repairRequestTabs.tabs[2].disabled;
      this.repairRequestTabs.tabs[3].disabled = !this.repairRequestTabs.tabs[3].disabled;
      this.repairRequestTabs.tabs[4].disabled = !this.repairRequestTabs.tabs[4].disabled;
      this.repairRequestTabs.tabs[5].disabled = !this.repairRequestTabs.tabs[5].disabled;
      this.repairRequestTabs.tabs[6].disabled = !this.repairRequestTabs.tabs[6].disabled;
    }
  }

  getRepairRequest() {
    this.repairRequestService.getRepairRequest(this.requestId).subscribe(
      d => {
        this.repairRequestDTO = d.Data;
        this.repairRequestTabs.tabs[1].disabled = false;
        this.repairRequestTabs.tabs[2].disabled = false;
        this.repairRequestTabs.tabs[3].disabled = false;
        this.repairRequestTabs.tabs[4].disabled = false;
        this.repairRequestTabs.tabs[5].disabled = false;
        this.repairRequestTabs.tabs[6].disabled = false;


        this.tabOneForm.patchValue({
          VesselName: this.repairRequestDTO.VesselName,
          IMONo: this.repairRequestDTO.IMONo,
          FlagId: this.repairRequestDTO.FlagId,
          VesselTypeId: this.repairRequestDTO.VesselTypeId,
          ClassificationSocietyId: this.repairRequestDTO.ClassificationSocietyId
        });
        this.tabTwoForm.patchValue({
          LengthOverAll: this.repairRequestDTO.LengthOverAll,
          LengthOverAllUnit: this.repairRequestDTO.LengthOverAllUnit,
          LengthBetweenPerpendiculars: this.repairRequestDTO.LengthBetweenPerpendiculars,
          LengthBetweenPerpendicularsUnit: this.repairRequestDTO.LengthBetweenPerpendicularsUnit,
          Beam: this.repairRequestDTO.Beam,
          BeamUnit: this.repairRequestDTO.BeamUnit,
          MouldedDepth: this.repairRequestDTO.MouldedDepth,
          MouldedDepthUnit: this.repairRequestDTO.MouldedDepthUnit,
          SuezCanalNetTonnage: this.repairRequestDTO.SuezCanalNetTonnage,
          SuezCanalGrossTonnage: this.repairRequestDTO.SuezCanalGrossTonnage
        });
        this.tabThreeForm.patchValue({
          Lightweight: this.repairRequestDTO.Lightweight,
          Deadweight: this.repairRequestDTO.Deadweight,
          Displacement: this.repairRequestDTO.Displacement,
          Draught: this.repairRequestDTO.Draught,
          DraughtUnit: this.repairRequestDTO.DraughtUnit,
          Trim: this.repairRequestDTO.Trim,
          TrimUnit: this.repairRequestDTO.TrimUnit,
          List: this.repairRequestDTO.List,
          ListUnit: this.repairRequestDTO.ListUnit,
        });
        this.tabFourForm.patchValue({
          Frequency: this.repairRequestDTO.Frequency,
          // FrequencyUnit: this.repairRequestDTO.FrequencyUnit,
          RatedCurrentDuringDocking: this.repairRequestDTO.RatedCurrentDuringDocking,
        });
        this.tabFiveForm.patchValue({
          DetailedScopeOfWork: this.repairRequestDTO.DetailedScopeOfWork,
          RequiredDockingDate: this.repairRequestDTO.RequiredDockingDate != null ? new Date(this.repairRequestDTO.RequiredDockingDate) : ''
        });
        this.tabSixForm.patchValue({
          GeneralArrangement: this.repairRequestDTO.GeneralArrangement,
          TankPlan: this.repairRequestDTO.TankPlan,
          LinesPlan: this.repairRequestDTO.LinesPlan,
          TransverseSectionPlan: this.repairRequestDTO.TransverseSectionPlan,
          DockingPlan: this.repairRequestDTO.DockingPlan,
          FreeGasCertificate: this.repairRequestDTO.FreeGasCertificate,
          WorkDescription: this.repairRequestDTO.WorkDescription
        });
        this.tabSevenForm.patchValue({
          NearestLocation: this.repairRequestDTO.NearestLocation,

          // Authority: this.repairRequestDTO.Authority,
          // Fax: this.repairRequestDTO.Fax,
          // MobileNumber: this.repairRequestDTO.MobileNumber,
          TermsAndConditions: true,
        });
        this.baseRequestDTO = this.repairRequestDTO.baseRequest;
        this.userInfo = {
          MobileNumber: this.repairRequestDTO.MobileNumber,
          Fax: this.repairRequestDTO.Fax
        };
        // this.repairRequestForm.patchValue({
        //   WorkDescription: this.repairRequestDTO.WorkDescription,
        //   Trim: this.repairRequestDTO.Trim,
        //   TrimUnit: this.repairRequestDTO.TrimUnit,
        //   List: this.repairRequestDTO.List,
        //   ListUnit: this.repairRequestDTO.ListUnit,
        //   MouldedDepth: this.repairRequestDTO.MouldedDepth,
        //   MouldedDepthUnit: this.repairRequestDTO.MouldedDepthUnit,
        //   NearestLocation: this.repairRequestDTO.NearestLocation,
        //   RatedCurrentDuringDocking: this.repairRequestDTO.RatedCurrentDuringDocking,
        //   SuezCanalGrossTonnage: this.repairRequestDTO.SuezCanalGrossTonnage,
        //   SuezCanalNetTonnage: this.repairRequestDTO.SuezCanalNetTonnage,
        //   Lightweight: this.repairRequestDTO.Lightweight,
        //   Authority: this.repairRequestDTO.Authority,
        //   Beam: this.repairRequestDTO.Beam,
        //   BeamUnit: this.repairRequestDTO.BeamUnit,
        //   Deadweight: this.repairRequestDTO.Deadweight,
        //   Frequency: this.repairRequestDTO.Frequency,
        //   FrequencyUnit: this.repairRequestDTO.FrequencyUnit,
        //   IMONo: this.repairRequestDTO.IMONo,
        //   LengthBetweenPerpendiculars: this.repairRequestDTO.LengthBetweenPerpendiculars,
        //   LengthBetweenPerpendicularsUnit: this.repairRequestDTO.LengthBetweenPerpendicularsUnit,
        //   LengthOverAll: this.repairRequestDTO.LengthOverAll,
        //   LengthOverAllUnit: this.repairRequestDTO.LengthOverAllUnit,
        //   VesselTypeId: this.repairRequestDTO.VesselTypeId,
        //   ClassificationSocietyId: this.repairRequestDTO.ClassificationSocietyId,
        //   FlagId: this.repairRequestDTO.FlagId,
        //   VesselName: this.repairRequestDTO.VesselName,
        //   RequiredDockingDate: this.repairRequestDTO.RequiredDockingDate,
        //   Displacement: this.repairRequestDTO.Displacement,
        //   Draught: this.repairRequestDTO.Draught,
        //   DraughtUnit: this.repairRequestDTO.DraughtUnit,
        //   Fax: this.repairRequestDTO.Fax,
        //   MobileNumber: this.repairRequestDTO.MobileNumber,
        //   CustomerName: this.repairRequestDTO.CustomerName,
        //   TermsAndConditions: true
        // });
        var baseUrl = AppConfig.settings.apiServer.UploadsUrl;
        var shipyardUploadsFolder = AppConfig.settings.apiServer.ShipyardUploadsFolder;

        this.dockingPlanAttachmentUrl = this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.DockingPlan) != undefined ?
          this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.DockingPlan).URL : '';
        this.dockingPlanAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.dockingPlanAttachmentUrl;
        this.dockingPlanExist = this.dockingPlanAttachmentUrl.substring(this.dockingPlanAttachmentUrl.lastIndexOf('/') + 1);

        this.generalArrangementAttachmentUrl = this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.GeneralArrangement) != undefined ?
          this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.GeneralArrangement).URL : '';
        this.generalArrangementAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.generalArrangementAttachmentUrl;
        this.generalArrangementExist = this.generalArrangementAttachmentUrl.substring(this.generalArrangementAttachmentUrl.lastIndexOf('/') + 1);
        this.tankPlanAttachmentUrl = this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.TankPlan) != undefined ?
          this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.TankPlan).URL : '';
        this.tankPlanAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.tankPlanAttachmentUrl;
        this.tankPlanExist = this.tankPlanAttachmentUrl.substring(this.tankPlanAttachmentUrl.lastIndexOf('/') + 1);

        this.linesPlanAttachmentUrl = this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.LinesPlan) != undefined ?
          this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.LinesPlan).URL : '';
        this.linesPlanAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.linesPlanAttachmentUrl;
        this.linesPlanExist = this.linesPlanAttachmentUrl.substring(this.linesPlanAttachmentUrl.lastIndexOf('/') + 1);

        this.transvewseSectionPlanAttachmentUrl = this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.TrnsverseSectionPlan) != undefined ?
          this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.TrnsverseSectionPlan).URL : '';
        this.transvewseSectionPlanAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.transvewseSectionPlanAttachmentUrl;
        this.transvewseSectionPlanExist = this.transvewseSectionPlanAttachmentUrl.substring(this.transvewseSectionPlanAttachmentUrl.lastIndexOf('/') + 1);

        this.gasCertificatePlanAttachmentUrl = this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.FreeGasCertificate) != undefined ?
          this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.FreeGasCertificate).URL : '';
        this.gasCertificatePlanAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.gasCertificatePlanAttachmentUrl;
        this.gasCertificatePlanExist = this.gasCertificatePlanAttachmentUrl.substring(this.gasCertificatePlanAttachmentUrl.lastIndexOf('/') + 1);

        this.detauiledScopeOfWorkAttachmentUrl = this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.DetailedScopeOfWork) != undefined ?
          this.repairRequestDTO.Attachments.find(x => x.AttachmentType == AttachmentType.DetailedScopeOfWork).URL : '';
        this.detauiledScopeOfWorkAttachmentUrl = baseUrl + shipyardUploadsFolder + "/" + this.detauiledScopeOfWorkAttachmentUrl;
        this.detauiledScopeOfWorkExist = this.detauiledScopeOfWorkAttachmentUrl.substring(this.detauiledScopeOfWorkAttachmentUrl.lastIndexOf('/') + 1);
      });

  }

  buildForm() {
    const numericNumberReg = '^-?[0-9]\\d*(\\.\\d{1,2})?$';
    this.tabOneForm = this.formBuilder.group({
      VesselName: ['', [Validators.required, Validators.maxLength(200), CustomValidators.textSpaceValidator()]],
      IMONo: ['', [Validators.required, Validators.pattern("^[0-9]{7,7}$")]],
      FlagId: [null, [Validators.required]],
      VesselTypeId: [null, [Validators.required]],
      ClassificationSocietyId: [null, [Validators.required]]
    });

    this.tabTwoForm = this.formBuilder.group({
      LengthOverAll: ['', [Validators.required, Validators.pattern(this.fractionRegex)]],
      LengthOverAllUnit: [null, [Validators.required]],
      LengthBetweenPerpendiculars: ['', [Validators.required, Validators.pattern(this.fractionRegex)]],
      LengthBetweenPerpendicularsUnit: [null, [Validators.required]],
      Beam: ['', [Validators.required, Validators.pattern(this.fractionRegex)]],
      BeamUnit: [null, [Validators.required]],
      MouldedDepth: ['', [Validators.required, Validators.pattern(this.fractionRegex)]],
      MouldedDepthUnit: [null, [Validators.required]],
      SuezCanalNetTonnage: ['', [Validators.pattern(this.numberRegex)]],
      SuezCanalGrossTonnage: ['', [Validators.required, Validators.pattern(this.numberRegex)]]
    });

    this.tabThreeForm = this.formBuilder.group({
      Lightweight: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      Deadweight: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      Displacement: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      Draught: ['', [Validators.required, Validators.pattern(this.fractionRegex)]],
      DraughtUnit: [null, [Validators.required]],
      Trim: ['', [Validators.required, Validators.pattern(this.fractionRegex)]],
      TrimUnit: [null, [Validators.required]],
      List: ['', [Validators.required, Validators.pattern(this.fractionRegex)]],
      ListUnit: [null, [Validators.required]],
    });
    this.tabFourForm = this.formBuilder.group({
      Frequency: [null, [Validators.required]],
      // FrequencyUnit: [null, [Validators.required]],
      RatedCurrentDuringDocking: ['', Validators.pattern(this.numberRegex)],
    });

    this.tabFiveForm = this.formBuilder.group({
      DetailedScopeOfWork: ['', [FileValidator.validate]],
      RequiredDockingDate: ['', [Validators.required, CustomValidators.dateValidator()]],
    });
    this.tabSixForm = this.formBuilder.group({
      GeneralArrangement: ['', [FileValidator.validate]],
      TankPlan: ['',],
      LinesPlan: ['',],
      TransverseSectionPlan: ['',],
      DockingPlan: ['', [FileValidator.validate]],
      FreeGasCertificate: ['',],
      WorkDescription: ['', [Validators.maxLength(500), CustomValidators.textSpaceValidator()]],
    });

    this.tabSevenForm = this.formBuilder.group({
      NearestLocation: ['', [Validators.required]],
      // Authority: ['',],
      TermsAndConditions: ['', [Validators.requiredTrue]]
    });


    // this.repairRequestForm.valueChanges.subscribe(
    //   d => {
    //     //console.log("dd", d);
    //   }
    // )
  }

  selectTab(tabId: number) {
    switch (tabId) {
      case 1:
        if (!this.validateTabOne) {
          this.submittedTabOneForm = true;
          return;
        }
        break;
      case 2:
        if (!this.validateTabTwo) {
          this.submittedtabTwoForm = true;
          return;
        }
        break;
      case 3:
        if (!this.validateTabThree) {
          this.submittedtabThreeForm = true;
          return;
        }
        break;
      case 4:
        if (!this.validateTabFour) {
          this.submittedtabFourForm = true;
          return;
        }
        break;
      case 5:
        if (!this.validateTabFive) {
          this.submittedtabFiveForm = true;
          return;
        }
        break;
      case 6:
        if (!this.validateTabSix) {
          this.submittedtabSixForm = true;
          return;
        }
        break;
      case 7:
        if (!this.validateTabSeven) {
          this.submittedtabSevenForm = true;
          return;
        }
        break;
      default:
        break;
    }
    this.repairRequestTabs.tabs[tabId].disabled = false;
    this.repairRequestTabs.tabs[tabId].active = true;

  }

  navigateToTab(tabId: number) {
    this.repairRequestTabs.tabs[tabId].disabled = false;
    this.repairRequestTabs.tabs[tabId].active = true;
  }
  // convenience getter for easy access to form fields
  get fTabOne(): any {
    return this.tabOneForm.controls;
  }
  get fTabTwo(): any {
    return this.tabTwoForm.controls;
  }
  get fTabThree(): any {
    return this.tabThreeForm.controls;
  }
  get fTabFour(): any {
    return this.tabFourForm.controls;
  }
  get fTabFive(): any {
    return this.tabFiveForm.controls;
  }
  get fTabSix(): any {
    return this.tabSixForm.controls;
  }

  get fTabSeven(): any {
    return this.tabSevenForm.controls;
  }

  get validateTabOne() {

    const isvalid = !this.tabOneForm.controls.VesselName.invalid && !this.tabOneForm.controls.IMONo.invalid
      && !this.tabOneForm.controls.ClassificationSocietyId.invalid && !this.tabOneForm.controls.VesselTypeId.invalid
      && !this.tabOneForm.controls.FlagId.invalid && this.tabOneForm.controls.FlagId.value != 'null'
      && this.tabOneForm.controls.VesselTypeId.value != 'null' && this.tabOneForm.controls.ClassificationSocietyId.value != 'null';
    return isvalid;
  }
  get validateTabTwo() {
    const isvalid = !this.tabTwoForm.controls.LengthOverAll.invalid &&
      !this.tabTwoForm.controls.LengthBetweenPerpendiculars.invalid &&
      !this.tabTwoForm.controls.Beam.invalid &&
      !this.tabTwoForm.controls.MouldedDepth.invalid &&
      !this.tabTwoForm.controls.MouldedDepthUnit.invalid &&
      this.tabTwoForm.controls.MouldedDepthUnit.value != 'null' &&
      !this.tabTwoForm.controls.LengthOverAllUnit.invalid &&
      this.tabTwoForm.controls.LengthOverAllUnit.value != 'null' &&
      !this.tabTwoForm.controls.LengthBetweenPerpendicularsUnit.invalid &&
      this.tabTwoForm.controls.LengthBetweenPerpendicularsUnit.value != 'null' &&
      !this.tabTwoForm.controls.BeamUnit.invalid &&
      this.tabTwoForm.controls.BeamUnit.value != 'null' &&
      !this.tabTwoForm.controls.Beam.invalid &&
      !this.tabTwoForm.controls.SuezCanalGrossTonnage.invalid;
    return isvalid;
  }
  get validateTabThree() {
    const isvalid = !this.tabThreeForm.controls.Lightweight.invalid
      && !this.tabThreeForm.controls.Deadweight.invalid &&
      !this.tabThreeForm.controls.Displacement.invalid &&
      !this.tabThreeForm.controls.Draught.invalid &&
      !this.tabThreeForm.controls.DraughtUnit.invalid &&
      this.tabThreeForm.controls.DraughtUnit.value != 'null' &&
      !this.tabThreeForm.controls.Trim.invalid &&
      !this.tabThreeForm.controls.TrimUnit.invalid &&
      this.tabThreeForm.controls.TrimUnit.value != 'null' &&
      !this.tabThreeForm.controls.List.invalid &&
      !this.tabThreeForm.controls.ListUnit.invalid &&
      this.tabThreeForm.controls.ListUnit.value != 'null';
    return isvalid;
  }
  get validateTabFour() {
    const isvalid = !this.tabFourForm.controls.Frequency.invalid &&
      this.tabFourForm.controls.Frequency.value != 'null';
    return isvalid;
  }
  get validateTabFive() {
    const isvalid = !this.tabFiveForm.controls.DetailedScopeOfWork.invalid
      && !this.tabFiveForm.controls.RequiredDockingDate.invalid;
    return isvalid;
  }
  get validateTabSix() {
    const isvalid = !this.tabSixForm.controls.DockingPlan.invalid
      && !this.tabSixForm.controls.GeneralArrangement.invalid &&
      !this.tabSixForm.controls.WorkDescription.invalid;
    return isvalid;
  }
  get validateTabSeven() {
    const isvalid = !this.tabSevenForm.controls.NearestLocation.invalid
      && !this.tabSevenForm.controls.TermsAndConditions.invalid;
    return isvalid;
  }

  get validateButton() {
    if (this.validateTabSix && this.validateTabFive && this.validateTabFour && this.validateTabThree && this.validateTabTwo && this.validateTabOne) {
      if (this.repairRequestTabs.tabs[6].disabled == false &&
        this.repairRequestTabs.tabs[6].active == true) {
        this.showSubmit = true;

      }
    }
    return this.showSubmit;
  }
  onSubmit(b) {
    this.submittedtabSevenForm = true;
    this.submittedtabSixForm = true;
    this.submittedtabFiveForm = true;
    this.submittedtabFourForm = true;
    this.submittedtabThreeForm = true;
    this.submittedtabTwoForm = true;
    this.submittedTabOneForm = true;
    if (this.tabOneForm.invalid || this.tabOneForm.controls['VesselTypeId'].value == "null" || this.tabOneForm.controls['FlagId'].value == "null" || this.tabOneForm.controls['ClassificationSocietyId'].value == "null") {
      this.navigateToTab(0);
      return;
    } else if (this.tabTwoForm.invalid || this.tabTwoForm.controls['LengthOverAllUnit'].value == "null" || this.tabTwoForm.controls['LengthBetweenPerpendicularsUnit'].value == "null" || this.tabTwoForm.controls['BeamUnit'].value == "null" || this.tabTwoForm.controls['MouldedDepthUnit'].value == "null") {
      this.navigateToTab(1);
      return;
    } else if (this.tabThreeForm.invalid || this.tabThreeForm.controls['DraughtUnit'].value == "null" || this.tabThreeForm.controls['TrimUnit'].value == "null" || this.tabThreeForm.controls['ListUnit'].value == "null") {
      this.navigateToTab(2);
      return;
    } else if (this.tabFourForm.invalid || this.tabFourForm.controls['Frequency'].value == "null") {
      this.navigateToTab(3);
      return;
    } else if (this.tabFiveForm.invalid) {
      this.navigateToTab(4);
      return;
    } else if (this.tabSixForm.invalid) {
      this.navigateToTab(5);
      return;
    } else if (this.tabSevenForm.invalid) {
      this.navigateToTab(6);
      return;
    }


    // stop here if form is invalid
    if (this.tabSevenForm.invalid || this.tabSixForm.invalid || this.tabFiveForm.invalid || this.tabFourForm.invalid || this.tabThreeForm.invalid || this.tabTwoForm.invalid || this.tabOneForm.invalid) {
      //   const invalidControls = this.tabTwoControls.nativeElement.querySelectorAll('.ng-invalid');
      //   if (invalidControls.length > 0) {
      //     //this.tabTwoControls.nativeElement.focus();
      //     invalidControls[0].focus();

      //   }
      return;
    }
    // this.tabSevenForm.controls['MobileNumber'].setValue(this.tabSevenForm.controls.MobileNumber.value.internationalNumber);
    //Enable Loader
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    // this.repairRequestDTO = this.repairRequestForm.getRawValue();
    this.repairRequestDTO = {
      ...this.tabOneForm.value, ...this.tabTwoForm.value, ...this.tabThreeForm.value, ...this.tabFourForm.value,
      ...this.tabFiveForm.value, ...this.tabSixForm.value, ...this.tabSevenForm.value
    };
    this.repairRequestDTO.MobileNumber = this.tabSevenForm.controls.MobileNumber.value;
    this.repairRequestDTO.Attachments = this.attachments;
    this.repairRequestDTO.RequestorId = this.authSrevice.currentUserValue.UserId;
    this.repairRequestDTO.UserName = this.authSrevice.currentUserValue.UserName;
    // if (this.attachmentDic[9] == null) {
    //   this.tabFiveForm.get('DetailedScopeOfWork').setValidators([FileValidator.validate]);
    //   this.alertService.error('please wait');
    //   this.globalSrv.isLoaderEnabled = false;

    //   this.navigateToTab(4);
    //   return;
    // } else {
    this.repairRequestDTO.DetailedScopeOfWork = this.attachmentDic[9] !== null ? this.attachmentDic[9] : "";



    this.repairRequestDTO.DockingPlan = this.attachments.length !== 0 ? this.attachments[1].URL : "";
    this.repairRequestDTO.GeneralArrangement = this.attachments.length !== 0 ? this.attachments[2].URL : "";
    this.repairRequestDTO.TankPlan = this.attachments.length > 3 ? this.attachments[3].URL : "";
    this.repairRequestDTO.LinesPlan = this.attachments.length > 4 ? this.attachments[4].URL : "";
    this.repairRequestDTO.TransverseSectionPlan = this.attachments.length > 5 ? this.attachments[5].URL : "";
    this.repairRequestDTO.FreeGasCertificate = this.attachments.length > 6 ? this.attachments[6].URL : "";



    this.repairRequestService.addRepairRequest(this.repairRequestDTO)
      .subscribe(
        (data: ResponseObject) => {
          this.responseObject = data;
          if (this.responseObject.Success) {

            let message: string;
            // this.repairRequestForm.reset();
            this.showRequest = false;
            this.loading = false;
            //Disable Loader
            this.globalSrv.isLoaderEnabled = false;
            // console.log("Success");
          }
          else {
            this.loading = false;
            this.isErrorMessage = true;
            this.showRequest = false;
            //Disable Loader
            this.globalSrv.isLoaderEnabled = false;
            // console.log("Fail");
          }
        });
  }

  public async onFileSelected(event, currFormControl, docName, attachmentType: AttachmentType, progressVariableName, key) {

    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      var formControlName = event.target.attributes['formControlName'].value;
      if (this.repairRequestTabs.tabs[4].active == true) {
        this.tabFiveForm.controls[formControlName].setValue("");
      } else {
        this.tabSixForm.controls[formControlName].setValue("");
      }
      var errorMessage = await this.translate.get('FRONT_USER.Floating_Carnes_Request_Form.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElements && invalidElements.length>0) {
      //   invalidElements[0].scrollIntoView();
      // }
      return false;

    }
    if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      var formControlName = event.target.attributes['formControlName'].value;
      if (this.repairRequestTabs.tabs[4].disabled == false &&
        this.repairRequestTabs.tabs[4].active == true) {
        this.tabFiveForm.controls[formControlName].setValue("");
      } else {
        this.tabSixForm.controls[formControlName].setValue("");
      }
      var errorMessageSize = await this.translate.get('FRONT_USER.MaxFileSizeTitle').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessageSize);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      // if (invalidElement && invalidElement.length>0) {
      //   invalidElement[0].scrollIntoView();
      // }
      return false;
    }
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ShipyardUploadsFolder);
    this.fileService.fileUploader(formData).subscribe(
      event => {

        if (event.type === HttpEventType.UploadProgress) {

          // This is an upload progress event. Compute and show the % done:
          var percentDone = Math.round(100 * event.loaded / event.total)
          this[progressVariableName] = percentDone;
          currFormControl.setErrors({ 'invalid': true });
        } else if (event instanceof HttpResponse) {
          currFormControl.setErrors(null);
          var jsonResponse = event.body.Data;
          var Url = jsonResponse.Url;
          var attachment = new Attachment();
          attachment.URL = Url;
          attachment.DocumentName = docName;
          attachment.AttachmentTypeId = attachmentType;
          this.attachments = this.attachments.filter(h => h.DocumentName != docName);
          this.attachments.push(attachment);
          this.attachmentDic[attachmentType] = Url;
        }
      }
    );
  }


  AddFiles(ev): void {
    //console.log(ev);
  }

  goToTermsAndConditions(): void {
    if (this.globalSrv.getLanguage() == Languages.Arabic)
        window.open(AppConfig.settings.apiServer.ShipyardTermsAR, '_blank');
    else
        window.open(AppConfig.settings.apiServer.ShipyardTermsEN, '_blank');
  }

}
